/**
 *
 * @module graphQlBuilder
 *
 */

import Exception from './../exception/entry';

const ContentException = Exception.ContentException;
const ErrorReason = Exception.ErrorReason;

/**
 *
 * @class GraphQlBuilder
 *
 */
export default class GraphQlBuilder {

    /**
     *
     * @param {String} url - The URL for which to build the query.
     * @param {HttpMethod} method - The method for which to build the query.
     * @desc Returns the URL for the query.
     * @returns {Promise<String>} The URL for the query.
     *
     */
    createQueryUrl(url, method) { // eslint-disable-line

        const methodSignature = 'createQueryUrl(url, method)';

        return new Promise((resolve) => {
            resolve(new ContentException('', [new ErrorReason('', `${methodSignature} - not-implemented`)]));
        });

    }

    /**
     *
     * @desc Returns the post content for the query.
     * @returns {Promise<String>} The post content for the query.
     *
     */
    createPostContent() {

        const methodSignature = 'createPostContent()';

        return new Promise((resolve) => {
            resolve(new ContentException('', [new ErrorReason('', `${methodSignature} - not-implemented`)]));
        });

    }

}



// WEBPACK FOOTER //
// ./src/services/content/graphQlBuilder.js